export const BRAND = { name: "المحاسب المحترف" };

export const CONTACT = {
  whatsapp: "966577856761",
  phone: "966577856761",
  email: "info@proaccerp.com",
};

export const UI = {
  toolbar: { xs: 64, sm: 64, md: 64 },
  containerMaxWidth: "lg",
};
